module.exports = "/_next/static/images/62709dcab2b806cacb00133d1f11b1ba-image-left-xs.jpg";